import React, { Component } from 'react';
import './Checkbox.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CheckboxFilterOption from './CheckboxFilterOption';
import ParameterErrors from '../errors/ParameterErrors';
import ReactTypeChecking from '../ui_core/ReactTypeChecking';
import Once from '../core/Once';
import HashSource from '../core/HashSource';
import stopEventPropagation from '../ui_core/stopEventPropagation';
const{throwNotProvided}=ParameterErrors;
export default class Checkbox extends Component {
	constructor(props){
		super(props)
		const {text, paths, toggleOnClick, onChange, stopEventsPropagating}=props;
		if(toggleOnClick===undefined)
			this._toggleOnClick=true;
		else this._toggleOnClick = toggleOnClick;
		this._stopEventsPropagating = stopEventsPropagating;
		this._text = text;
		this._paths = paths;
		this._get_dispatchChange_lexicalClosure= this._get_dispatchChange_lexicalClosure.bind(this);
		this._onCallbackChange = onChange?new Once(this._get_dispatchChange_lexicalClosure(onChange)):null;
		this.toggle = this.toggle.bind(this);
		this._stopEventPropagation = this._stopEventPropagation.bind(this);
		this.state ={checked:false};
		this._children = props.children;
		this._checkboxRef = React.createRef();
		this._elementRef = React.createRef();
		this._checked = false;
	}
	_get_dispatchChange_lexicalClosure(onChange){
		return ()=>{
			onChange({checked:this._checked})
		};
	}
	_stopEventPropagation(e){
		if(!e)e=window.event;
		e.stopPropagation&&e.stopPropagation();
		e.preventDefault&&e.preventDefault();
	}
	componentDidMount(){
		if(!this._toggleOnClick)return;
		const onceToggle = new Once(this.toggle);
		const element = this._elementRef.current;
		element.addEventListener('click', (e)=>{
			if(this._stopEventsPropagating)
				this._stopEventPropagation(e);
			onceToggle.trigger();
		});
	}
	get checked(){
		return this._checked;
	}
	set checked(value){
		this._checked = value;
		this.setState({checked:value})
		this._onCallbackChange?.trigger();
	}
	toggle(){
		this.checked = !this._checked;
		this.setState({checked:this.checked })
		this._onCallbackChange?.trigger();
		setTimeout(()=>{
			this._checkboxRef.current.checked = this._checked;
		}, 0);
	}
	render() {
		const paths = [];
		const className = "checkbox"+(this.state.checked?' checked':'');
		if(!this._paths)
			paths.push((<path key={HashSource.next()} fill='none' d='M1.73 12.91l6.37 6.37L22.79 4.59' />));
		else
			this._paths.forEach(p=>paths.push(ReactTypeChecking.isElement(p)?p:(<path key={HashSource.next()}  fill='none' d={p}/>)));
		return (<label className={className} ref={this._elementRef}>
		  <span className="checkbox__input">
			<input type="checkbox" onChange={()=>{}}checked={this.state.checked} name="checkbox" ref={this._checkboxRef}/>
			<span className="tick-container">
			  <svg xmlns='http://www.w3.org/2000/svg' className="tick" viewBox='0 0 24 24' aria-hidden="true" focusable="false">
			  {paths}
			</svg>
			</span>
		  </span>
		  <span className="checkbox__label">{this._text}{this._children}</span>
		</label>);
	}
}
